import {axiosInstance} from "../utils/axios";

export const getRepeatOptions = async () => {
    return await axiosInstance.get('/teachers/virtual-class/repeats');
};
